import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getGroupsForDropdown,
  getFactoryByGroupID,
  getRoutesForDropDown,
  getSuppliersByFilters,
  createSupplierTags,   
};

async function getGroupsForDropdown() {
  var groupArray = [];
  const response = await CommonGet('/api/Group/GetAllGroups', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
  }
  return groupArray;
}

async function getFactoryByGroupID(groupID) {
  var factoryArray = [];
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + groupID)
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function getRoutesForDropDown(factoryID) {
  var routeArray = [];
  const response = await CommonGet('/api/Group/GetRouteByFactoryID', 'factoryID=' + factoryID)
  for (let item of Object.entries(response.data)) {
    routeArray[item[1]["routeID"]] = item[1]["routeName"]
  }
  return routeArray;
}

async function getSuppliersByFilters(groupID, factoryID, routeID, registrationNumber) {
  const response = await CommonGet(
    '/api/SupplierQRCode/GetSuppliersByFilters',
    `groupID=${groupID}&factoryID=${factoryID}&routeID=${routeID}&registrationNumber=${registrationNumber}`
  );
  return response.data;
}

async function createSupplierTags(tagGenerationModel) {
  const response = await CommonPost(
    '/api/SupplierQRCode/CreateSupplierTags',
    null,
    tagGenerationModel
  );
  return response; 
}




